export default "__VITE_ASSET__CBCnR7FT__"